// FloatingDebugButton.js
import React, { useState } from 'react';
import { TouchableOpacity, View, StyleSheet, Modal } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import ServerDiagnostic from './ServerDiagnostic';

const FloatingDebugButton = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const navigation = useNavigation();

  return (
    <>
      {/* Floating Button */}
      <TouchableOpacity
        style={styles.floatingButton}
        onPress={() => {
          // Try to navigate, fallback to modal if navigation not available
          try {
            navigation.navigate('ServerDiagnostic');
          } catch (error) {
            setModalVisible(true);
          }
        }}
      >
        <View style={styles.buttonContent}>
          <Text style={styles.buttonText}>🔧</Text>
        </View>
      </TouchableOpacity>

      {/* Modal fallback */}
      <Modal
        visible={modalVisible}
        animationType="slide"
        onRequestClose={() => setModalVisible(false)}
      >
        <ServerDiagnostic />
        <Button title="Close" onPress={() => setModalVisible(false)} />
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  floatingButton: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    backgroundColor: '#FF9800',
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 999,
  },
  buttonContent: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 24,
  },
});

export default FloatingDebugButton;